import React from 'react'
import { Switch, Redirect } from 'react-router-dom'

import { RouteWithLayout } from './components'
import { Main as MainLayout, Minimal as MinimalLayout } from './layouts'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import {
  Dashboard as DashboardView,
  ProductList as ProductListView,
  UserList as UserListView,
  Typography as TypographyView,
  Icons as IconsView,
  Account as AccountView,
  Settings as SettingsView,
  SignUp as SignUpView,
  SignIn as SignInView,
  NotFound as NotFoundView,
  FrontPageBookameeting as FrontPageBookameetingView,
  FrontPageBookameetingCampaign as FrontPageBookameetingCampaignView
} from './views'
import { useSelector } from 'react-redux'
import fiLocale from 'date-fns/locale/fi'
import daLocale from 'date-fns/locale/da'
import noLocale from 'date-fns/locale/nb'
import svLocale from 'date-fns/locale/sv'
import enLocale from 'date-fns/locale/en-US'

const localeMap = {
  fi: fiLocale,
  da: daLocale,
  no: noLocale,
  sv: svLocale,
  en: enLocale
}

const Routes = () => {
  const currentLangcode = useSelector((state) => state.language.langcode)

  return (
    <MuiPickersUtilsProvider
      utils={DateFnsUtils}
      locale={localeMap[currentLangcode]}>
      <Switch>
        // redirect if no endpoint secified
        <Redirect
          exact
          from="/dashboard-statistics"
          to={'/dashboard-statistics/analytics'}
        />
        // redirect if language is en
        <Redirect
          exact
          from="/en/dashboard-statistics/*"
          to={'/dashboard-statistics/*'}
        />
        <Redirect
          exact
          from="/*/dashboard-statistics"
          to={'/*/dashboard-statistics/analytics'}
        />
        // Dashboard
        <RouteWithLayout
          component={DashboardView}
          exact
          layout={MainLayout}
          path="/:langcode/dashboard-statistics/analytics"
        />
        <RouteWithLayout
          component={DashboardView}
          exact
          layout={MainLayout}
          path="/dashboard-statistics/analytics"
        />
        <RouteWithLayout
          component={UserListView}
          exact
          layout={MainLayout}
          path="/:langcode/dashboard-statistics/users"
        />
        <RouteWithLayout
          component={UserListView}
          exact
          layout={MainLayout}
          path="/dashboard-statistics/users"
        />
        <RouteWithLayout
          component={ProductListView}
          exact
          layout={MainLayout}
          path="/:langcode/dashboard-statistics/products"
        />
        <RouteWithLayout
          component={ProductListView}
          exact
          layout={MainLayout}
          path="/dashboard-statistics/products"
        />
        <RouteWithLayout
          component={TypographyView}
          exact
          layout={MainLayout}
          path="/:langcode/dashboard-statistics/typography"
        />
        <RouteWithLayout
          component={TypographyView}
          exact
          layout={MainLayout}
          path="/dashboard-statistics/typography"
        />
        <RouteWithLayout
          component={IconsView}
          exact
          layout={MainLayout}
          path="/:langcode/dashboard-statistics/icons"
        />
        <RouteWithLayout
          component={IconsView}
          exact
          layout={MainLayout}
          path="/dashboard-statistics/icons"
        />
        <RouteWithLayout
          component={AccountView}
          exact
          layout={MainLayout}
          path="/:langcode/dashboard-statistics/account"
        />
        <RouteWithLayout
          component={AccountView}
          exact
          layout={MainLayout}
          path="/dashboard-statistics/account"
        />
        <RouteWithLayout
          component={SettingsView}
          exact
          layout={MainLayout}
          path="/:langcode/dashboard-statistics/settings"
        />
        <RouteWithLayout
          component={SettingsView}
          exact
          layout={MainLayout}
          path="/dashboard-statistics/settings"
        />
        <RouteWithLayout
          component={SignUpView}
          exact
          layout={MinimalLayout}
          path="/:langcode/dashboard-statistics/sign-up"
        />
        <RouteWithLayout
          component={SignUpView}
          exact
          layout={MinimalLayout}
          path="/dashboard-statistics/sign-up"
        />
        <RouteWithLayout
          component={SignInView}
          exact
          layout={MinimalLayout}
          path="/:langcode/dashboard-statistics/sign-in"
        />
        <RouteWithLayout
          component={SignInView}
          exact
          layout={MinimalLayout}
          path="/dashboard-statistics/sign-in"
        />
        <RouteWithLayout
          component={FrontPageBookameetingCampaignView}
          exact
          layout={MinimalLayout}
          path="/:langcode/campaigns"
        />
        <RouteWithLayout
          component={FrontPageBookameetingCampaignView}
          exact
          layout={MinimalLayout}
          path="/campaigns"
        />
        <RouteWithLayout
          component={FrontPageBookameetingView}
          exact
          layout={MinimalLayout}
          path="/:langcode"
        />
        <RouteWithLayout
          component={FrontPageBookameetingView}
          exact
          layout={MinimalLayout}
          path="/"
        />
        <RouteWithLayout
          component={NotFoundView}
          exact
          layout={MinimalLayout}
          path="/dashboard-statistics/not-found"
        />
        {/* <Redirect to="/dashboard-statistics/not-found" /> */}
      </Switch>
    </MuiPickersUtilsProvider>
  )
}

export default Routes
